import { createSlice } from "@reduxjs/toolkit";

const updateEmptyState = {
  actualizado: false,
};

export const updateSlice = createSlice({
  name: "update",
  initialState: updateEmptyState,
  reducers: {
    DataUpdatedStatus: (state, action) => {
      state.actualizado = action.payload.actualizado
    },
  },
});

// Action creators are generated for each case reducer function
export const { DataUpdatedStatus } = updateSlice.actions;

export default updateSlice.reducer;
